import { useState } from "react";

import Page from "../../components/Page";
import { useQuery, useQueryClient } from "react-query";
import { getIndicatorsOverdue } from "../../services/Indicators.service";
import { sendNotificationOverdue } from "../../services/Mail.service";
import { swalClose, swalLoading } from "../../components/Swal";
import { toast } from "react-toastify";


const Configs = () => {

    const [leader, setLeader] = useState({})
    const [respondent, setRespondent] = useState({})
    const queryClient = useQueryClient()

    const {} = useQuery(['emails', 1 ],
        () => {
            return getIndicatorsOverdue(1)
        },
        {
            onSuccess: (res) => {
                setLeader(res)
            },
            refetchOnWindowFocus: false,
            retry: 1
        })

    const {} = useQuery(['emails', 2],
        () => {
            return getIndicatorsOverdue(2)
        },
        {
            onSuccess: (res) => {
                setRespondent(res)
            },
            refetchOnWindowFocus: false,
            retry: 1
        })

    const sendNotification = async (status) => {

        swalLoading()

        const response = await sendNotificationOverdue(status)

        if (response.success) {
            const key = status === 'draft' ? 2 : 1;
            queryClient.invalidateQueries(["emails", key])
            toast.success('E-mails enviados com sucesso!')
            swalClose()
        }
    }

    return (
        <Page label="Administrativo" icon="bi bi-person-gear">
            <nav className="mt-4">
                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                    <button className="nav-link active" id="nav-email-tab" data-bs-toggle="tab" data-bs-target="#nav-email"
                            type="button" role="tab" aria-controls="nav-email" aria-selected="true">E-mail
                    </button>
                </div>
            </nav>
            <div className="tab-content" id="nav-tabContent">
                <div className="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-email-tab"
                     tabIndex="0">

                    <div className="card border-top-0 rounded-0 pb-4">
                        <div className="card-body">
                            <h4>Líder ESG</h4>
                            <p>Indicadores em atraso: { leader?.overdue }</p>
                            <p>Notificados hoje: { leader?.notify }</p>
                            <button
                                type="button"
                                className="btn btn-success"
                                disabled={ leader?.overdue === leader?.notify }
                                onClick={ () => sendNotification('approval_esg') }
                            >
                                Enviar
                            </button>

                            <hr />

                            <h4>Respondente</h4>
                            <p>Indicadores em atraso: { respondent?.overdue }</p>
                            <p>Notificados hoje: { respondent?.notify }</p>
                            <button
                                type="button"
                                className="btn btn-success"
                                disabled={ respondent?.notify === respondent?.overdue }
                                onClick={ () => sendNotification('draft') }
                            >
                                Enviar
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </Page>
    )
}

export default Configs
